import type { PropsWithChildren } from 'react';

import { GoogleOAuthProvider } from '@react-oauth/google';

interface GoogleAuthProviderProps extends PropsWithChildren {}

export function GoogleAuthProvider(props: GoogleAuthProviderProps) {
    const { children } = props;

    return (
        <GoogleOAuthProvider
            clientId={process.env['ALGOTECH_ENV_GOOGLE_OAUTH_CLIENT_ID']}
        >
            {children}
        </GoogleOAuthProvider>
    );
}
